import { supabase } from './supabase';
import { CURRENT_LEGAL_VERSION } from '../config/legal';

// Records the point-of-purchase billing acknowledgment for the current user.
// record-acceptance stamps the authoritative version from app_config server-side;
// CURRENT_LEGAL_VERSION is sent only as a fallback.
export async function recordBillingAck(): Promise<{ ok: boolean; error?: string }> {
  try {
    const { data: { session } } = await supabase.auth.getSession();
    const token = session?.access_token;
    if (!token) return { ok: false, error: 'Your session has expired. Please sign in again.' };

    const res = await fetch('/.netlify/functions/record-acceptance', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
      body: JSON.stringify({ documentTypes: ['billing'], version: CURRENT_LEGAL_VERSION }),
    });
    if (!res.ok) return { ok: false, error: 'Could not record your billing acknowledgment. Please try again.' };
    return { ok: true };
  } catch {
    return { ok: false, error: 'Could not record your billing acknowledgment. Please try again.' };
  }
}
